import styled from "styled-components";

export const ContainerInputPhone = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label`
  width: 100%;
  margin: 0 0 0.5rem;

  font-family: Inter;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5rem;

  color: ${({ theme }) => theme.checkoutStepsOffers?.textColor};
`;

export const Required = styled.span`
  font-family: Inter;
  font-size: 1rem;
  line-height: 1.5rem;
  color: ${({ theme }) => theme.checkoutStepsOffers?.red};
`;

interface IContentInputPhone {
  error: boolean;
}
export const ContentInputPhone = styled.div<IContentInputPhone>`
  display: flex;
  align-items: center;
  padding: 1rem 1.5rem;

  width: 100%;
  height: 3.4rem;
  padding: 0 1rem;

  font-family: Inter;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;

  border-radius: 0.5rem;

  transition: 0.5s ease-in-out;

  color: ${({ theme }) => theme.checkoutStepsOffers?.textColor};
  background: ${({ theme }) => theme.checkoutOnePage?.inputBackground};

  position: relative;

  border: 0.094rem solid
    ${(props) =>
      props.error
        ? props.theme?.checkoutOnePage?.red
        : props.theme?.checkoutOnePage?.inputBorderColor};

  &[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  &[type="number"] {
    -moz-appearance: textfield;
    appearance: textfield;
  }

  &::placeholder {
    color: ${({ theme }) => theme.checkoutStepsOffers?.placeholderColor};
  }

  &:disabled {
    opacity: 0.8;
  }

  &:hover {
    border: 0.094rem solid
      ${(props) =>
        `${
          props.theme?.checkoutStepsOffers?.checkoutPrimaryColor ||
          props.theme?.colors?.primary
        }a0`};
  }

  &:focus {
    border: 0.094rem solid
      ${(props) =>
        `${
          props.theme?.checkoutStepsOffers?.checkoutPrimaryColor ||
          props.theme?.colors?.primary
        }a8`};
  }

  .react-tel-input {
    .form-control.ant-input-checkout {
      border-radius: 8px;
      width: 100%;

      background: ${({ theme }) => theme.checkoutOnePage?.inputBackground};
      border-color: ${({ theme }) => theme.checkoutOnePage?.inputBackground};
      outline: none !important;
    }

    .flag-dropdown {
      border: 1px solid ${({ theme }) => theme.checkoutOnePage?.inputBackground};
      background-color: ${({ theme }) =>
        theme.checkoutOnePage?.inputBackground} !important;
    }

    .selected-flag {
      background: ${({ theme }) =>
        theme.checkoutOnePage?.inputBackground} !important;
    }

    .country-list {
      background: ${({ theme }) => theme.checkoutStepsOffers?.inputBackground};

      .dial-code {
        color: ${({ theme }) => theme.colors.textColor};
      }
      .country.highlight {
        background: ${({ theme }) => theme.colors.inputBackgroundColor};
      }

      li:hover {
        background: ${({ theme }) => theme.colors.inputBackgroundColor};
      }
    }
  }
`;

export const InvalidMessage = styled.span`
  width: 100%;
  margin: 0.5rem 0 0;
  font-family: Inter;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1rem;

  color: ${({ theme }) => theme.checkoutStepsOffers?.red};
`;
